/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogAddressInfo = {
    trxCount?: string;
    ADDR: string;
    ADDRT: ZerogAddressInfo.ADDRT;
    NM: string;
    SB: string;
    BL: string;
    BLVAL: string;
    BLP: string;
    TRXCNT: string;
};

export namespace ZerogAddressInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

